import { render, staticRenderFns } from "./EmployeeDepartmentForm.vue?vue&type=template&id=50112f36&"
import script from "./EmployeeDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports